// Is iOS
const userAgent = navigator.userAgent.toLowerCase();
const isIOS = /iphone|ipod|ipad/.test(userAgent);
export default isIOS;
